module.exports = __webpack_public_path__ + "static/img/partner-bsyj.eb87783.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-bsyj.png
// module id = ox6m
// module chunks = 34